export default {"src":"/_next/static/media/auth5.b83fc543.svg","height":139,"width":138,"blurWidth":0,"blurHeight":0};